/**
 * Common styles for switches throughout the app
 * This centralizes styling for MUI switches with vertical centering
 */

// New Color Palette: Ocean & Marine Tones
// Primary: Light Sea Green (#20B2AA, #66D4D0)
// Secondary: Terracotta/Clay (#E17055, #D63031)
// Accent: Warm Gold (#FDCB6E, #F39C12)
// Background: Warm Charcoal (#2D3436, #636E72)
// Text: Warm Cream (#FFF5E6, #F8F4E6)

export const commonSwitchStyles = {
  '& .MuiSwitch-switchBase': {
    color: '#66D4D0', // Light Sea Green
    padding: '2px',
    transform: 'translateY(-50%)',
    top: '50%',
    transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
    '&.Mui-checked': {
      color: '#20B2AA', // Light Sea Green
      transform: 'translateY(-50%) translateX(16px)',
      transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
      '& + .MuiSwitch-track': {
        backgroundColor: '#1A9B99', // Darker Light Sea Green
        opacity: 0.8,
        transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#20B2AA', // Light Sea Green
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: 'rgba(255, 255, 255, 0.3)',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#636E72', // Warm gray
    opacity: 0.6,
    borderRadius: 10,
    transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  '&:hover': {
    '& .MuiSwitch-thumb': { 
      boxShadow: '0 3px 6px 0 rgba(0,0,0,0.3)'
    },
  },
}; 